import vi18n from "vue-i18n";
import Vue from "vue";
import enUS from "vant/es/locale/lang/en-US";
import zhCN from "vant/es/locale/lang/zh-CN";
import cn from "@/kabala/language/zh-CN.js";
import en from "@/kabala/language/en-US.js";

Vue.use(vi18n);
const i18n = new vi18n({
    // 设置语言
    locale: window.localStorage.getItem('kabala.locale') || "zh-CN",
    // 语言包
    messages: {
        'zh-CN': {
            ...cn,
            ...zhCN
        },
        'en-US': {
            ...en,
            ...enUS
        },
    },
});

export default i18n;